import React from "react";
import "./style.css";
import { scroller, Element } from "react-scroll";
import { Carousel } from "react-bootstrap";
import fotoHotel from "../../assets/Fotos Hotel/Frente/frentehotel.jpeg";
import FrentHotel2 from "../../assets/Home/FrenteHotel2.jpg";

const WHATSAPP_RESERVA =
  "https://wa.me/5542933008907?text=Ol%C3%A1!%20Tudo%20bem%3F%0AGostaria%20de%20efetuar%20uma%20reserva%20no%20Hotel%20Marechal%20Express.%0APoderia%2C%20por%20favor%2C%20me%20informar%20sobre%20a%20disponibilidade%20e%20os%20procedimentos%20para%20confirmar%20a%20reserva%3F";

const Home = () => {
  const scrollToContent = () => {
    scroller.scrollTo("conteudo-principal", {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
    });
  };

  const destaques = [
    "Recepção 24 horas",
    "Café da manhã incluso",
    "Wi‑Fi",
    "Garagem fechada · 24h",
  ];

  return (
    <>
      <section className="hero-cinematic" aria-label="Apresentação do hotel">
        <div className="hero-cinematic__bg">
          <img
            src={FrentHotel2}
            alt="Fachada do Hotel Marechal Express"
            className="hero-cinematic__bg-img"
            decoding="async"
          />
        </div>
        {/* <div className="hero-cinematic__media">
          <video className="hero-cinematic__video" autoPlay muted loop playsInline>
            <source src={videoHotel} type="video/mp4" />
            Seu navegador não suporta vídeo em HTML5.
          </video>
        </div> */}
        <div className="hero-cinematic__vignette" aria-hidden />
        <div className="hero-cinematic__grain" aria-hidden />

        <div className="hero-cinematic__layout container">
          <div className="hero-cinematic__panel">
            <div className="hero-cinematic__brand-line" aria-hidden />
            <p className="hero-cinematic__eyebrow">Laranjeiras do Sul · Paraná</p>
            <h1 className="hero-cinematic__title">
              O seu refúgio
              <span className="hero-cinematic__title-accent"> no Marechal Express</span>
            </h1>
            <p className="hero-cinematic__lead">
              Quartos amplos, café da manhã servido com carinho e equipe presente a qualquer hora —
              pensado para quem viaja a trabalho, em família ou a passeio.
            </p>
            <ul className="hero-cinematic__chips" aria-label="Destaques">
              {destaques.map((t) => (
                <li key={t}>{t}</li>
              ))}
            </ul>
            <div className="hero-cinematic__actions">
              <button type="button" className="btn btn-hotel-outline" onClick={scrollToContent}>
                Ver experiências
              </button>
              <a
                className="btn btn-hotel-whatsapp "
                href={WHATSAPP_RESERVA}
                target="_blank"
                rel="noopener noreferrer"
              >
                WhatsApp — reservas
              </a>
            </div>
            <p className="hero-cinematic__fineprint">
              R. Mal. Cândido Rondon, 2290 · Centro — Paraná · Laranjeiras do Sul .
            </p>
          </div>
        </div>




        <button
          type="button"
          className="hero-cinematic__scroll"
          onClick={scrollToContent}
          aria-label="Rolar para o conteúdo principal"
        >
          <span className="hero-cinematic__scroll-label">Explorar</span>
          <span className="hero-cinematic__scroll-icon" aria-hidden />
        </button>
      </section>

      <Element name="conteudo-principal">
        <section className="home-section container py-5">
          <header className="text-center mb-5" data-aos="fade-up">
            <p className="section-eyebrow">Experiência</p>
            <h2 className="section-heading text-center d-inline-block">Conheça nossa estrutura</h2>
            <p className="lead text-muted mx-auto mb-0" style={{ maxWidth: "36rem" }}>
              Um ambiente acolhedor nos detalhes — do primeiro contato à sua despedida.
            </p>
          </header>

          <div className="row g-4">
            {[
              {
                title: "Fachada e acesso",
                embed:
                  "https://www.google.com/maps/embed?pb=!4v1752249863835!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eWRNQUNnWGE.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f0.5283465038289137!4f4.719093032124064!5f1.5366265233210208",
              },
              {
                title: "Entrada",
                embed:
                  "https://www.google.com/maps/embed?pb=!4v1752249901572!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUjJTUC1NV2Y2VnRFQUFDRVY.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f13.739857456418097!4f0.18426917473615845!5f0.7820865974627469",
              },
              {
                title: "Ambientes internos",
                embed:
                  "https://www.google.com/maps/embed?pb=!4v1752249979847!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUnNnbXRBR2Y5eWhzQUJHbG4.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f15.381399901532163!4f12.666151421470275!5f0.7820865974627469",
              },
            ].map((item, i) => (
              <div key={item.title} className="col-md-4 col-12" data-aos="fade-up" data-aos-delay={i * 100}>
                <figure className="map-embed surface-card mb-0 h-100">
                  <figcaption className="map-embed__caption">{item.title}</figcaption>
                  <div className="ratio ratio-4x3 map-embed__frame">
                    <iframe
                      title={item.title}
                      src={item.embed}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                </figure>
              </div>
            ))}
          </div>
        </section>

        <section className="home-section home-section--muted py-5">
          <div className="container">
            <header className="text-center mb-5" data-aos="fade-up">
              <p className="section-eyebrow">Acomodações</p>
              <h2 className="section-heading text-center d-inline-block">Principais quartos</h2>
              <p className="text-muted mx-auto mb-0" style={{ maxWidth: "32rem" }}>
                Conforto para família ou estadias individuais — confira vistas em 360°.
              </p>
            </header>

            <div className="row g-4 justify-content-center">
              <div className="col-md-6 col-sm-12" data-aos="fade-right">
                <h3 className="h5 text-center mb-3 font-display">Família</h3>
                <div className="rounded-4 overflow-hidden shadow-sm hotel-carousel-wrap">
                  <Carousel controls indicators interval={8000} className="hotel-carousel">
                    {[
                      "https://www.google.com/maps/embed?pb=!4v1752251128555!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXpFQURDX1Y.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f4.467291559052327!4f-18.803783451673453!5f0.7820865974627469",
                      "https://www.google.com/maps/embed?pb=!4v1752251583643!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXdnQURjcGs.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f1.5397249916061693!4f-21.66958697142752!5f0.7820865974627469",
                      "https://www.google.com/maps/embed?pb=!4v1752251762106!6m8!1m7!1sCAoSHENJQUJJaEFEeWRFUnNnbXRBR2Y5eXNZQUNqc0U.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f284.843174306903!4f-30.93014931536773!5f0.7820865974627469",
                    ].map((src, idx) => (
                      <Carousel.Item key={src}>
                        <div className="ratio ratio-4x3">
                          <iframe src={src} title={`Família ${idx + 1}`} allowFullScreen loading="lazy" />
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </div>

              <div className="col-md-6 col-sm-12" data-aos="fade-left">
                <h3 className="h5 text-center mb-3 font-display">Individual</h3>
                <div className="rounded-4 overflow-hidden shadow-sm hotel-carousel-wrap">
                  <Carousel controls indicators interval={8000} className="hotel-carousel">
                    {[
                      "https://www.google.com/maps/embed?pb=!4v1752251831971!6m8!1m7!1sCAoSHENJQUJJaEFBM2lsV0lTQUhUbWY5eXZRQUFodS0.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f337.5017694929508!4f-20.990801934843873!5f0.7820865974627469",
                      "https://www.google.com/maps/embed?pb=!4v1752251867251!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eXVBQUEtcko.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f346.5128934493369!4f-21.25961070835268!5f0.7820865974627469",
                      "https://www.google.com/maps/embed?pb=!4v1752251702860!6m8!1m7!1sCAoSHENJQUJJaEFEeWNLemxTb1czR2Y5eW9zQUNXQWM.!2m2!1d-25.40649259814523!2d-52.41347302568855!3f9.22866841311685!4f-6.260513438457309!5f0.7820865974627469",
                    ].map((src, idx) => (
                      <Carousel.Item key={src}>
                        <div className="ratio ratio-4x3">
                          <iframe src={src} title={`Individual ${idx + 1}`} allowFullScreen loading="lazy" />
                        </div>
                      </Carousel.Item>
                    ))}
                  </Carousel>
                </div>
              </div>
            </div>

            <div className="text-center mt-5" data-aos="zoom-in">
              <a
                className="btn btn-hotel-primary btn-lg px-5"
                href={WHATSAPP_RESERVA}
                target="_blank"
                rel="noopener noreferrer"
              >
                Reserve sua estadia
              </a>
            </div>
          </div>
        </section>

        <section className="home-section container py-5">
          <div className="row align-items-center g-5">
            <div className="col-md-6" data-aos="fade-right">
              <p className="section-eyebrow">Sobre nós</p>
              <h2 className="section-heading section-heading--start mb-3">Hospitalidade que marca</h2>
              <p className="fs-5 text-muted">
                Localizado em uma região acessível da cidade, o Hotel Marechal Express oferece
                conforto, praticidade e um atendimento acolhedor — seja para família ou viagem a
                trabalho.
              </p>
              <p className="text-muted mb-0">
                Nossa missão é tornar sua hospedagem inesquecível, unindo tecnologia e calor humano
                com excelência em cada detalhe.
              </p>
            </div>
            <div className="col-md-6 text-center" data-aos="fade-left">
              <div className="about-photo frame-reveal">
                <img src={fotoHotel} alt="Fachada do Hotel Marechal Express" className="img-fluid" />
              </div>
            </div>
          </div>
        </section>
      </Element>
    </>
  );
};

export default Home;
